import { isNil } from 'lodash';

import {
  BankingInfoAccountTypeEnum,
  BOUserTypeEnum,
  BOUsersBankingInfoTypeEnum,
  ProfileTypeEnum,
  FullBOUserResponseModel,
} from 'api/backofficeApiClient';

const getBankingAccountTypeLabel = (
  type: BankingInfoAccountTypeEnum | string | undefined,
) => {
  switch (type) {
    case BankingInfoAccountTypeEnum.Savings:
      return 'Savings';
    case BankingInfoAccountTypeEnum.Checking:
      return 'Checking';

    default:
      return '';
  }
};

const getBankingAccountTypesOptions = () => [
  {
    value: BankingInfoAccountTypeEnum.Savings,
    label: getBankingAccountTypeLabel(BankingInfoAccountTypeEnum.Savings),
  },
  {
    value: BankingInfoAccountTypeEnum.Checking,
    label: getBankingAccountTypeLabel(BankingInfoAccountTypeEnum.Checking),
  },
];

const getAccountTypeLabel = (boUserType?: BOUserTypeEnum) => {
  switch (boUserType) {
    case BOUserTypeEnum.Company:
      return 'Company';

    case BOUserTypeEnum.SelfEmployed:
      return 'Self-employed';

    case BOUserTypeEnum.International:
      return 'International';

    default:
      return '';
  }
};

const getProfileTypeLabel = (userProfileType?: ProfileTypeEnum) => {
  switch (userProfileType) {
    case ProfileTypeEnum.Recruiter:
      return 'Member';

    case ProfileTypeEnum.Corporate:
      return 'Corporate TA';

    default:
      return '';
  }
};

const getBankingInfoTypeLabel = (
  bankingInfoType: BOUsersBankingInfoTypeEnum,
) => {
  switch (bankingInfoType) {
    case BOUsersBankingInfoTypeEnum.DirectDeposit:
      return 'Direct deposit';

    case BOUsersBankingInfoTypeEnum.MailMyChecks:
      return 'Mail the checks';

    case BOUsersBankingInfoTypeEnum.International:
      return 'International';

    default:
      return '';
  }
};

export enum MemberProfileSectionsEnum {
  PricingAgreement = 'Pricing agreement',
  EntityInformation = 'Entity information',
  BankingInformation = 'Banking information',
  BillingInformation = 'Billing information',
}

const getUnfilledSectionForMyProfile = (
  myProfile?: FullBOUserResponseModel,
  isCorporateTa?: boolean,
) => {
  const unfilledSections: Array<MemberProfileSectionsEnum> = [];

  if (
    isNil(myProfile?.businessInfo?.priceAgreement) ||
    !myProfile?.businessInfo?.priceAgreement?.isConfirmation
  ) {
    unfilledSections.push(MemberProfileSectionsEnum.PricingAgreement);
  }

  if (isNil(myProfile?.businessInfo?.entityInformation)) {
    unfilledSections.push(MemberProfileSectionsEnum.EntityInformation);
  }

  if (isNil(myProfile?.bankingInformation) && !isCorporateTa) {
    unfilledSections.push(MemberProfileSectionsEnum.BankingInformation);
  }

  if (isCorporateTa && isNil(myProfile?.corporateInfo?.billingInfo)) {
    unfilledSections.push(MemberProfileSectionsEnum.BillingInformation);
  }

  return unfilledSections;
};

export {
  getBankingAccountTypeLabel,
  getBankingAccountTypesOptions,
  getAccountTypeLabel,
  getProfileTypeLabel,
  getBankingInfoTypeLabel,
  getUnfilledSectionForMyProfile,
};
